module.exports = __webpack_public_path__ + "static/media/app-mobile-easypm.d58934c8.svg";